import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation } from "@/mixins/index";
import { levelDetails } from "@/api/dataAll/levelDetails";
export default {
  name: "levelDetails",
  mixins: [tabulation],
  data: function data() {
    return {
      tableData: [],
      Dynamic: []
    };
  },
  created: function created() {},
  methods: {
    searchClick: function searchClick() {
      var _this = this;

      if (this.value2.length > 0) {
        this.searchData.starttime = this.value2[0];
        this.searchData.endtime = this.value2[1];
      }

      this.reqLoading = true;
      levelDetails(this.searchData).then(function (res) {
        if (res.status == 200) {
          var objToTitle = function objToTitle(obj) {
            return Object.keys(obj).map(function (k) {
              return obj[k];
            });
          };

          var objToKey = function objToKey(obj) {
            return Object.keys(obj).map(function (k) {
              return k;
            });
          };

          var pageData = res.data;
          var columns = [{
            label: _this.$t('noviceGuide'),
            prop: 'start'
          }];
          var data = [];
          var complete = {
            start: ''
          };
          var number = {
            start: _this.$t('dailyNewUserCount')
          };
          var listNum = 0;
          pageData.map(function (item, index) {
            var k = objToKey(item)[0];
            columns.push.apply(columns, [{
              label: k,
              prop: index + 'date'
            }, {
              label: '',
              prop: index + 'complete'
            }, {
              label: '',
              prop: index + 'runOff'
            }]);
            number[index + 'date'] = +item[k].new_account_num;
            complete[index + 'date'] = _this.$t('startPeopleCount');
            complete[index + 'complete'] = _this.$t('completeCount');
            complete[index + 'runOff'] = _this.$t('runOffRate');
            var IN = -1;

            for (var i in item[k].guanka) {
              data.push({});
              IN += 1;
              listNum = IN;
              var taskData = {
                start: i
              };
              taskData[index + 'date'] = item[k].guanka[i].begin_num || 0;
              taskData[index + 'complete'] = item[k].guanka[i].end_num || 0;
              taskData[index + 'runOff'] = item[k].guanka[i].run_off || '0%';
              data[IN] = _objectSpread(_objectSpread({}, data[IN]), taskData);
            }
          });
          data.unshift(complete);
          data.unshift(number);
          data.splice(listNum + 3, data.length - listNum + 3);
          _this.Dynamic = columns;
          _this.tableData = data;

          _this.$nextTick(function () {
            _this.getTableRight();
          });
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    exportdata: function exportdata() {
      var columns = this.Dynamic;
      var data = this.tableData;
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    }
  }
};